import { apiSlice } from '../../api/apiSlice';
import {
    SCORECARD_AGENT_DISPUTE_DETAILS
} from '../../constants';

export const agentDisputeDetailsSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardAgentDisputeDetails: builder.query({
            query: (arg: any) => {
                const { employeenumber, supervisornumber, year, month, scorecardversionid } = arg;
                return {
                    url: SCORECARD_AGENT_DISPUTE_DETAILS,
                    params: { employeenumber, supervisornumber, year, month, scorecardversionid },
                };
            },
        providesTags: ['Disputes'],
        // keepUnusedDataFor:0,

        }),
    }),
});

export const {
    useGetScorecardAgentDisputeDetailsQuery,

} = agentDisputeDetailsSlice;
